(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["ff-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.stickyHeader = document.getElementById("sticky-header");
      this.logo = document.querySelector(".header__heading-logo");
      this.anchorListText = document.getElementsByClassName("anchor-list");
      this.liList = document.getElementsByClassName("right-list-item");
      this.searchBarIcons = document.getElementsByClassName("search-bar");
      this.hamburguerIcon = document.querySelector(".icon-hamburger");
      this.myAccount = document.getElementById("my_account");
      this.mainContent = document.getElementById("MainContent");
      this.weglot = document.querySelector(".ff-weglot-desk")
      this.caretArrow = this.weglot.parentElement.children[1].children[0]
      this.template = this.dataset.template;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      /* Control clases en mobile */
      if (screen.width < 980) {
        this.stickyHeader.classList.remove("bg-transparent");
        this.stickyHeader.classList.add("bg-color");
        this.stickyHeader.classList.add("border-bottom");
        this.stickyHeader.style.position="relative";
        this.logo.classList.remove("inverter");
        this.hamburguerIcon.classList.remove("inverter");
      }else if (screen.width >= 980 && this.template === "index" ) {
        this.caretArrow.classList.add("color-alternative")
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (window.pageYOffset === 0) {
        if (this.template === "index" && screen.width > 979) {
          this.hamburguerIcon.classList.add("inverter");
          this.stickyHeader.classList.add('fixed');
          this.header.classList.add("fixed")
          this.header.style.position = "sticky"
          this.logo.classList.add("inverter")
          this.stickyHeader.classList.add('bg-transparent');
          this.stickyHeader.classList.remove('bg-color');
          this.stickyHeader.classList.remove('border-bottom');
          this.myAccount.classList.add("color-alternative")
          this.caretArrow.classList.add("color-alternative")
          for (const anchor of this.anchorListText) {
            anchor.classList.add("color-alternative")
          }
          for (const li of this.liList) {
            li.classList.add("color-alternative")
          }
          for (const span of this.searchBarIcons) {
            if (span.children.length !== 0) {
              span.children[0].classList.add("color-alternative");
            }else{
              span.classList.add("color-alternative")
            }
          }
        }else if (this.template !== "index" || this.template === "index" && screen.width < 979) {
          this.stickyHeader.style.position = 'sticky';
          this.stickyHeader.style.display = "initial";
          this.stickyHeader.style.opacity = 1;
          this.stickyHeader.firstElementChild.classList.add("border-bottom")
          this.stickyHeader.classList.remove("border-bottom")
        }
      }
      else if( window.pageYOffset !== 0){
        this.hamburguerIcon.classList.remove("inverter")
        if (this.template === "index") {
          this.header.style.position = "sticky"
          if (window.pageYOffset < 120) {
            this.header.classList.remove("fixed")
          }else{
            this.header.classList.add("fixed")
          }
          this.logo.classList.remove("inverter")
          this.stickyHeader.classList.remove('bg-transparent');
          this.stickyHeader.classList.remove('fixed');
          this.stickyHeader.classList.add('bg-color');
          !this.stickyHeader.firstElementChild.classList.contains("border-bottom") && this.stickyHeader.classList.add("border-bottom");
          this.myAccount.classList.remove("color-alternative")
          this.caretArrow.classList.remove("color-alternative")
          for (const anchor of this.anchorListText) {
            anchor.classList.remove("color-alternative")
          }
          for (const li of this.liList) {
            li.classList.remove("color-alternative")
          }
          for (const span of this.searchBarIcons) {
            if (span.children.length !== 0) {
              span.children[0].classList.remove("color-alternative");
            }else{
              span.classList.remove("color-alternative")
            }
          }
        }else{
          !this.stickyHeader.firstElementChild.classList.contains("border-bottom") && this.stickyHeader.classList.add("border-bottom");
          this.stickyHeader.firstElementChild.classList.remove("border-bottom")
          if (window.pageYOffset < 120) {
            this.header.classList.remove("fixed")
          }else{
            this.header.classList.add("fixed")
          }
        }
      }
     
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      /* currentScrolltop es la posición en Y anterior y scrollTop es la nueva posicion en Y */
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        /* scroll down */
        if (this.template === "index") {
          this.stickyHeader.style.opacity=0;
          this.stickyHeader.style.display="none";
        }else{
          this.stickyHeader.style.opacity=0;
          this.stickyHeader.style.display="none";
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop >= this.headerBounds.bottom) {
        /* scroll up */
        if (this.template !== "index") {
          this.stickyHeader.style.opacity=1;
          this.stickyHeader.style.display="block";
          if (window.pageYOffset === 0) {
            this.stickyHeader.style.position="sticky";
            this.stickyHeader.style.display="block";
          }
        }else if (this.template === "index" && screen.width > 979) {
          this.stickyHeader.style.opacity=1;
          this.stickyHeader.style.position="fixed";
          this.stickyHeader.style.top=0;
          this.stickyHeader.style.display="block";
        }else if (this.template === "index" && screen.width < 980){
          this.stickyHeader.style.opacity=1;
          this.stickyHeader.style.position="fixed";
          this.stickyHeader.style.top=0;
          this.stickyHeader.style.display="block";
          if (window.pageYOffset < 120) {
            this.stickyHeader.style.position="sticky";
            this.stickyHeader.style.display="block";
          }
        }

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      if (this.header.classList.contains("fixed")) {
        this.mainContent.style.paddingTop = `${this.header.offsetHeight}px`
      }else{
        this.mainContent.style.paddingTop = "0"
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove( 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

})();
